import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import stl from "./CarPriceTableSection.module.css";
import useHelpers from "@hooks/useHelpers";
import useDetectDeviceByMediaQuery from "@hooks/useDetectDeviceByMediaQuery";
var SPLIT_POINT = {
  mobile: 4,
  desktop_large: 4,
  desktop_small: 4
};
var findTopPrice = function findTopPrice(carPricesDataStructure) {
  var _carPricesDataStructu;
  return carPricesDataStructure === null || carPricesDataStructure === void 0 ? void 0 : (_carPricesDataStructu = carPricesDataStructure.reduce(function (prev, current) {
    return parseInt(prev.max_price) > parseInt(current.max_price) ? prev : current;
  })) === null || _carPricesDataStructu === void 0 ? void 0 : _carPricesDataStructu.max_price;
};
var findBottomPrice = function findBottomPrice(carPricesDataStructure) {
  var _carPricesDataStructu2;
  return carPricesDataStructure === null || carPricesDataStructure === void 0 ? void 0 : (_carPricesDataStructu2 = carPricesDataStructure.reduce(function (prev, current) {
    return parseInt(prev.min_price) < parseInt(current.min_price) ? prev : current;
  })) === null || _carPricesDataStructu2 === void 0 ? void 0 : _carPricesDataStructu2.min_price;
};
function formatNumber(number) {
  var _number$toString;
  return number === null || number === void 0 ? void 0 : (_number$toString = number.toString()) === null || _number$toString === void 0 ? void 0 : _number$toString.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
var NoData = function NoData() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.noDataContainer
  }, /*#__PURE__*/React.createElement("i", {
    className: stl.searchBigIcon
  }), /*#__PURE__*/React.createElement("strong", null, t("عذرًا", {
    ns: "web_services"
  })), /*#__PURE__*/React.createElement("p", null, t("لا تتوفر لدينا حاليًا معلومات عن أسعار السيارة المختارة.", {
    ns: "web_services"
  })));
};
var TableRow = function TableRow(_ref) {
  var carPriceRow = _ref.carPriceRow;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var link = carPriceRow.link.includes("http") ? carPriceRow.link.split('.com')[1] : carPriceRow.link;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.tableRow
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
    href: createUrl(link)
  }, carPriceRow.title)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "m-show"
  }, t("السعر الأدنى", {
    ns: "web_services"
  })), /*#__PURE__*/React.createElement("strong", null, formatNumber(carPriceRow === null || carPriceRow === void 0 ? void 0 : carPriceRow.min_price), " ", /*#__PURE__*/React.createElement("span", {
    className: "no-currency-icon"
  }, t("ر.س", {
    ns: "web_services"
  })))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "m-show"
  }, t("السعر الأعلى", {
    ns: "web_services"
  })), /*#__PURE__*/React.createElement("strong", null, formatNumber(carPriceRow === null || carPriceRow === void 0 ? void 0 : carPriceRow.max_price), " ", /*#__PURE__*/React.createElement("span", {
    className: "no-currency-icon"
  }, t("ر.س", {
    ns: "web_services"
  })))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "m-show"
  }, t("متوسط الأسعار", {
    ns: "web_services"
  })), /*#__PURE__*/React.createElement("strong", null, formatNumber(carPriceRow === null || carPriceRow === void 0 ? void 0 : carPriceRow.avg_price), " ", /*#__PURE__*/React.createElement("span", {
    className: "no-currency-icon"
  }, t("ر.س", {
    ns: "web_services"
  }))))));
};
var CarPriceTableSection = function CarPriceTableSection(props) {
  var title = props.title,
    disclaimer = props.disclaimer,
    subtitle = props.subtitle,
    cta = props.cta,
    carPricesDataStructure = props.carPricesDataStructure;
  var _useTranslation3 = useTranslation(),
    t = _useTranslation3.t;
  var device = useDetectDeviceByMediaQuery();

  // format number
  var price_top = formatNumber(findTopPrice(carPricesDataStructure));
  var price_bottom = formatNumber(findBottomPrice(carPricesDataStructure));
  if (!carPricesDataStructure || carPricesDataStructure.length === 0) {
    return NoData();
  }
  var showAllTableRows = function showAllTableRows(e) {
    e.target.classList.add("hide");
    var tableRow = document.querySelector("#fullTable");
    tableRow === null || tableRow === void 0 ? void 0 : tableRow.classList.remove("hide");
  };
  var carPricesDataStructure_1 = carPricesDataStructure.slice(0, SPLIT_POINT[device]);
  var carPricesDataStructure_2 = carPricesDataStructure.slice(SPLIT_POINT[device], 999);
  return /*#__PURE__*/React.createElement("div", {
    className: [stl.container].join(" ")
  }, /*#__PURE__*/React.createElement(props.headingType, {
    className: stl.headingStyle
  }, title), subtitle && /*#__PURE__*/React.createElement("p", {
    className: [stl.UpperNote, "line-height-24 font-size-18 no-currency-icon"].join(" "),
    dangerouslySetInnerHTML: {
      __html: subtitle.replace("{price_top}", "<b>".concat(price_top, "</b>")).replace("{price_bottom}", "<b>".concat(price_bottom, "</b>"))
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.tableContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: [stl.tableHeading, "m-hide"].join(" ")
  }, /*#__PURE__*/React.createElement("strong", null, t("الماركة والموديل", {
    ns: "web_services"
  })), /*#__PURE__*/React.createElement("strong", null, t("السعر الأدنى", {
    ns: "web_services"
  })), /*#__PURE__*/React.createElement("strong", null, t("السعر الأعلى", {
    ns: "web_services"
  })), /*#__PURE__*/React.createElement("strong", null, t("متوسط الأسعار", {
    ns: "web_services"
  }))), carPricesDataStructure_1.map(function (carPriceRow, i) {
    return /*#__PURE__*/React.createElement(TableRow, {
      carPriceRow: carPriceRow
    });
  }), /*#__PURE__*/React.createElement("div", {
    className: ["hide"].join(" "),
    id: "fullTable"
  }, carPricesDataStructure_2.map(function (carPriceRow, i) {
    return /*#__PURE__*/React.createElement(TableRow, {
      carPriceRow: carPriceRow
    });
  }))), cta.text && carPricesDataStructure_2.length > 0 && /*#__PURE__*/React.createElement("button", {
    onClick: showAllTableRows,
    className: ["blueBtn", stl.link].join(" ")
  }, cta.text), /*#__PURE__*/React.createElement("p", {
    className: stl.note
  }, /*#__PURE__*/React.createElement("i", {
    className: stl.infoIcon
  }), disclaimer));
};
export default CarPriceTableSection;